const ZOOM_SELECTORS = ['.bgImage', '.bgVideo'];
const PARALLAX_SELECTORS = ['.bgImage', '.bgVideo'];
const REVEAL_SELECTORS = ['.bgImage', '.bgVideo'];
export { ZOOM_SELECTORS, PARALLAX_SELECTORS, REVEAL_SELECTORS };
//# sourceMappingURL=balataConsts.js.map